import * as platformDetection from "platform";
import appConfig from "../appconfig";

export const redirectToAppStoreForFriendInvite = (tenantSettings) => {
	if (!location.search.includes("friend_invite")) {
		return;
	}
	if (appConfig.channelAlias() !== "mobileBrowser") {
		return;
	}
	
	const device = platformDetection.parse(navigator.userAgent);
	const androidOSfamily = ["Android"];
	const macOSfamily = ["iOS", "OS X"];
	const params = new URLSearchParams(document.location.search);
	const friendInvite = params.get("friend_invite");
	if (friendInvite === "true") {
		if (macOSfamily.includes(device.os.family)) {
			window.location.href = tenantSettings.appLinks.appStore;
		}
		if (androidOSfamily.includes(device.os.family)) {
			window.location.href = tenantSettings.appLinks.playStore;
		}
	}
};